import { all } from "redux-saga/effects";
import providerSaga from "@/store/sagas/providerSaga";
import operatorSaga from "@/store/sagas/operatorSaga";
import subapplicationSaga from "@/store/sagas/subApplicationSaga";
import vdiTransactionSaga from "@/store/sagas/vdiTransactionSaga";
import dashboardSaga from "@/store/sagas/dashboardSaga";
import userSaga from "@/store/sagas/userSaga";
import roleSaga from "./roleSaga";
import locationSaga from "./locationSaga";
import marketSaga from "./marketSaga";
import productSaga from "./productSaga";
import reconciliationSaga from './reconciliationSaga';
import alertSaga from "./alertSaga";
import deviceSaga from "./deviceSaga";
import mmsSalesSaga from "./mmsSalesSaga";
import cronJobsTrackerSaga from "./cronJobTrackerSaga";
import quickPayMasterProductSaga from "./quickPaySaga";
import targetedReconciliationSaga from "./targetedReconciliationSaga";
import smartCoolerProductsSaga from "./smartCoolerProductsSaga";
import coolerTransactionSaga from "./coolerTransactionSaga";
import approvedProductsSaga from "./approvedProductsSaga";
import appLogSaga from "./appLogsSaga";
import smartCoolerSaga from "./smartCoolerSaga";
import { watchGlobalNotifications } from "./apiResponseWatcherSaga";

function* rootSaga() {
  yield all([
    watchGlobalNotifications(),
    dashboardSaga(),
    providerSaga(),
    operatorSaga(),
    subapplicationSaga(),
    vdiTransactionSaga(),
    userSaga(),
    roleSaga(),
    locationSaga(),
    marketSaga(),
    productSaga(),
    reconciliationSaga(),
    alertSaga(),
    deviceSaga(),
    mmsSalesSaga(),
    cronJobsTrackerSaga(),
    quickPayMasterProductSaga(),
    targetedReconciliationSaga(),
    smartCoolerProductsSaga(),
    coolerTransactionSaga(),
    approvedProductsSaga(),
    appLogSaga(),
    smartCoolerSaga(),
  ]);
}

export default rootSaga;
